import { AuthContainer } from "SC";

export const SignUpLayout = ({ children }) => {

  const currentYear =  new Date().getFullYear();

  return (
    <AuthContainer>
      <div className="text-sm flex-1 flex-shrink-0 flex flex-col justify-center items-center p-2">
        {children}
      </div>
      <div className="mb-4 text-gray-500 text-sm flex-grow-0 flex-shrink-0">
        Copyright © {currentYear} Referral Stream. All rights reserved.
      </div>
    </AuthContainer>
  );
};
